var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    { attrs: { id: "page" } },
    [
      _c("the-title", { attrs: { title: "Access Denied" } }),
      _vm._v(" "),
      _c("div", { staticClass: "shape-area flip cyan-inner white-outer" }),
      _vm._v(" "),
      _c(
        "b-container",
        [
          _c(
            "b-row",
            { staticClass: "justify-content-center" },
            [
              _c("b-col", { staticClass: "text-center" }, [
                _c("h2", { staticClass: "not-found-content-header" }, [
                  _vm._v("Oops!"),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "not-found-content-text" }, [
                  _vm._v("You don't have access to this page!"),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "shape-area reversed cyan-inner purple-outer" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }